import { I18nComponente } from "@/types/gerais"

export const ONovoMembroi18n: I18nComponente = {
  "pt-BR": {
    adicionarMembro: "adicionar profissional membro",
    naoHaNenhumMembro: "não há nenhum profissional membro",
  },
  "es-CO": {
    adicionarMembro: "agregar profesional miembro",
    naoHaNenhumMembro: "no hay ningún profesional miembro",
  }
}
